import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { initializeMetaPixel, identifyUser } from '@/services/analyticsService';

interface MetaPixelInitializerProps {
    userData: any;
    localStorageData: any;
}

const MetaPixelInitializer: React.FC<MetaPixelInitializerProps> = ({ userData, localStorageData }) => {
    const settingsData = useSelector((state: any) => state.settingsList?.data?.settingsData);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        // Don't initialize if settings data is not available yet
        if (!settingsData) {
            console.log('Meta Pixel: Settings data not available yet');
            return;
        }

        // Don't re-initialize if already done
        if (isInitialized) {
            return;
        }

        // Parse Meta Pixel settings from API response
        let metaPixelId = '';
        let metaPixelEnabled = false;

        if (settingsData.meta_pixel?.settings) {
            try {
                const settings = JSON.parse(settingsData.meta_pixel.settings);
                metaPixelId = settings.meta_pixel_id || '';
                metaPixelEnabled = settings.meta_pixel_enabled || false;
                
                console.log('Meta Pixel settings from API:', settings);
            } catch (error) {
                console.error('Error parsing Meta Pixel settings:', error);
            }
        }

        // Initialize Meta Pixel if we have an ID and it's enabled
        if (metaPixelId && metaPixelEnabled) {
            console.log('Initializing Meta Pixel with ID:', metaPixelId);
            initializeMetaPixel(metaPixelId, true);
            
            // Identify user in Meta Pixel if available
            if (userData?.id) {
                identifyUser(userData.id.toString(), {
                    email: userData.email,
                    firstName: userData.first_name,
                    lastName: userData.last_name,
                    userName: userData.userName,
                    clientId: userData.client_id,
                    organization: localStorageData.organizationName,
                    plan: localStorageData.plan,
                    created_at: localStorageData.orgCreatedAt,
                    monthly_spend: localStorageData.monthlyPayment,
                    last_payment_date: localStorageData.lastPaymentDate,
                    last_payment_amount: localStorageData.lastPaymentAmount,
                    organization_status: localStorageData.orgStatus,
                });
            }
            
            setIsInitialized(true);
        } else {
            console.log('Meta Pixel not configured or disabled');
            setIsInitialized(true);
        }
    }, [settingsData, userData, localStorageData, isInitialized]);

    return null; // This component doesn't render anything
};

export default MetaPixelInitializer; 